// Mock data pour Younited Clone

export const mockClients = [
  {
    id: '1',
    firstName: 'Jacky',
    lastName: 'Pruvost',
    email: 'pruvost.jacky@hotmail.com',
    phone: '07 67 86 48 15',
    address: '2 RUE DU 8 MAI',
    city: 'MONTREUIL',
    zipCode: '80130',
    password: 'client123',
    role: 'client',
    accountNumber: 'FR76 1870 60** **42 11$7 **** 2**',
    balance: 15420.50,
    profilePicture: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Jacky',
    createdAt: '2025-02-01'
  },
  {
    id: '2',
    firstName: 'Marie',
    lastName: 'Dupont',
    email: 'marie.dupont@gmail.com',
    phone: '06 12 34 56 78',
    address: '15 Avenue des Champs',
    city: 'PARIS',
    zipCode: '75008',
    password: 'client456',
    role: 'client',
    accountNumber: 'FR76 3000 30** **12 34$5 **** 6**',
    balance: 25600.00,
    profilePicture: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Marie',
    createdAt: '2025-01-15'
  },
  {
    id: '3',
    firstName: 'Pierre',
    lastName: 'Martin',
    email: 'pierre.martin@outlook.fr',
    phone: '06 98 76 54 32',
    address: '8 Rue de la République',
    city: 'LYON',
    zipCode: '69002',
    password: 'client789',
    role: 'client',
    accountNumber: 'FR76 1234 56** **78 90$1 **** 2**',
    balance: 8750.25,
    profilePicture: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Pierre',
    createdAt: '2024-12-20'
  }
];

export const mockAdmin = {
  id: 'admin1',
  firstName: 'Admin',
  lastName: 'Younited',
  email: 'admin@younited.fr',
  password: 'admin123',
  role: 'admin'
};

export const mockDocuments = [
  {
    id: 'doc1',
    clientId: '1',
    name: 'Younited - Prêt Personnel',
    date: 'Février 2026',
    type: 'Contrat',
    status: 'Disponible'
  },
  {
    id: 'doc2',
    clientId: '1',
    name: 'Younited - Vente à Crédit',
    date: 'Septembre 2025',
    type: 'Contrat',
    status: 'Disponible'
  },
  {
    id: 'doc3',
    clientId: '1',
    name: 'Guide des cartes Younited',
    date: 'Février 2026',
    type: 'Guide',
    status: 'Disponible'
  }
];

export const mockContracts = [
  {
    id: 'contract1',
    clientId: '1',
    type: 'Prêt Personnel',
    amount: 20000,
    accountNumber: 'FR76 1870 60** **42 11$7 **** 2**',
    status: 'Actif',
    startDate: '2025-01-15',
    monthlyPayment: 350
  },
  {
    id: 'contract2',
    clientId: '2',
    type: 'Crédit Auto',
    amount: 15000,
    accountNumber: 'FR76 3000 30** **12 34$5 **** 6**',
    status: 'Actif',
    startDate: '2024-11-20',
    monthlyPayment: 280
  }
];

export const mockInsurances = [
  {
    id: 'ins1',
    clientId: '1',
    type: 'Assurance Emprunteur',
    name: 'Vente à Crédit',
    description: 'Grâce à votre assurance, vous êtes protégé(e) contre les accidents de la vie',
    status: 'Actif'
  },
  {
    id: 'ins2',
    clientId: '1',
    type: 'Assurance Biens et Personnes',
    name: 'Protection Quotidienne',
    description: 'Des assurances adaptées selon vos besoins',
    status: 'Disponible'
  }
];

export const mockLoanApplications = [
  {
    id: 'loan1',
    clientId: '1',
    amount: 20000,
    type: 'Prêt Personnel',
    status: 'Acceptation',
    step: 2,
    totalSteps: 4,
    createdAt: '2025-06-15',
    estimatedDays: 10
  }
];

export const mockTransactions = [
  {
    id: 'trans1',
    clientId: '1',
    type: 'credit',
    amount: 5000,
    description: 'Déblocage de fonds - Prêt personnel',
    date: '2025-06-20'
  },
  {
    id: 'trans2',
    clientId: '1',
    type: 'debit',
    amount: 350,
    description: 'Mensualité prêt personnel',
    date: '2025-06-25'
  }
];
